// Extracts the round id from a wouter location pathname (e.g.
// "/round/r-abc/funder/..." -> "r-abc"), or null when not under a round.
//
// IMPORTANT: the QueueProvider key must derive its round id from the URL, NOT
// from the ImpersonateContext `value.round.id`. `Round` (a descendant of
// QueueProvider) sets that context value on mount and clears it on unmount, so
// keying the ancestor on it creates an infinite remount loop
// (mount -> set value -> key changes -> remount -> unmount -> clear -> key
// changes -> remount -> ...). The URL is stable across Round's mount/unmount.
export function roundIdFromPathname(pathname: string): string | null {
  return pathname.match(/^\/round\/([^/]+)/)?.[1] ?? null;
}
